import { RECEIVE_DATA_OBJECTS, STORE_DATA_OBJECTS, UPDATE_DATA_OBJECT } from '@inpart-io/devtools-vue';
import { type IConference, type IMeeting, meetingsManager } from '@inpart-io/padme-iap';
import { type ActionTree } from 'vuex';

import { isDataObject } from '@/services/data-object-helper';
import { CONFERENCE_MODULE } from '@/store/conference-module';

export const MAKE_PUBLIC = 'makePublic';
export const MAKE_PRIVATE = 'makePrivate';
export const ADD_LEADS_TO_MEETING = 'addLeadsToMeeting';
export const REMOVE_LEADS_FROM_MEETING = 'removeLeadsFromMeeting';

export const actions: ActionTree<IMeeting, unknown> = {
    async [MAKE_PUBLIC](context, { meetingId }: { meetingId: number }) {
        const result = await meetingsManager.makeMeetingPublic(meetingId);

        if (result !== undefined) {
            context.commit(RECEIVE_DATA_OBJECTS, { dataObjectList: [result] });
        }
    },
    async [MAKE_PRIVATE](context, { meetingId }: { meetingId: number }) {
        const result = await meetingsManager.makeMeetingPrivate(meetingId);

        if (result !== undefined) {
            context.commit(RECEIVE_DATA_OBJECTS, { dataObjectList: [result] });
        }
    },
    async [ADD_LEADS_TO_MEETING](
        context,
        { leadIdList, meetingId, properties }: { leadIdList: number[]; meetingId: number; properties?: string }
    ): Promise<number[]> {
        const meetingsToUpdate = {
            dobjId: meetingId,
            projects: { '@value': leadIdList, '@operation': 'ADD' }
        };
        return context.dispatch(UPDATE_DATA_OBJECT, { dataObjectList: [meetingsToUpdate], properties });
    },
    async [REMOVE_LEADS_FROM_MEETING](
        context,
        { leadIdList, meetingId, properties }: { leadIdList: number[]; meetingId: number; properties?: string }
    ): Promise<number[]> {
        const meetingsToUpdate = {
            dobjId: meetingId,
            projects: { '@value': leadIdList, '@operation': 'REMOVE' }
        };
        return context.dispatch(UPDATE_DATA_OBJECT, { dataObjectList: [meetingsToUpdate], properties });
    },
    [STORE_DATA_OBJECTS](context, { dataObjectList }: { dataObjectList: IMeeting[] }) {
        const meetings: IMeeting[] = [];
        const conferences: IConference[] = [];

        dataObjectList.forEach((meeting) => {
            const _meeting = Object.assign({}, meeting);
            const _conference = meeting.conference;

            // Extract conferences objects if necessary
            if (isDataObject<IConference>(_conference)) {
                const conference = Object.assign({}, _conference);
                _meeting.conference = conference.dobjId;
                conferences.push(conference);
            }

            meetings.push(_meeting);
        });

        if (meetings.length > 0) {
            context.commit(RECEIVE_DATA_OBJECTS, { dataObjectList: meetings });
        }
        if (conferences.length > 0) {
            void context.dispatch(`${CONFERENCE_MODULE}/${STORE_DATA_OBJECTS}`, { dataObjectList: conferences }, { root: true });
        }
    }
};
